export function AdminLogo() {
  return (
    <div className={"flex items-center space-x-3"}>
      <img
        className={"h-10"}
        src={"/norma_logo.png"}
        alt={"Norma's teaching"}
      />
      <h4 className={"font-bold text-lg"}>Norma's Teaching</h4>
    </div>
  );
}
